
import React from "react";
import { formatDistanceToNow } from "date-fns";
import { Edit, Trash2 } from "lucide-react";
import { Template } from "@/lib/types";
import { Button } from "@/components/ui/button";

interface TemplateItemProps {
  template: Template;
  onEdit: (template: Template) => void;
  onDelete: (template: Template) => void;
}

const TemplateItem: React.FC<TemplateItemProps> = ({ template, onEdit, onDelete }) => {
  const timeAgo = formatDistanceToNow(new Date(template.updated_at), { addSuffix: true });
  
  return (
    <div className="grid grid-cols-4 items-center py-4 px-4 hover:bg-accent/50">
      <div className="font-medium">{template.name}</div>
      <div className="text-muted-foreground">{timeAgo}</div>
      <div className="text-muted-foreground">{template.usage_count}</div>
      <div className="flex justify-end gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onEdit(template)}
        >
          <Edit className="h-4 w-4" />
          <span className="sr-only">Edit</span>
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDelete(template)}
        >
          <Trash2 className="h-4 w-4" />
          <span className="sr-only">Delete</span>
        </Button>
      </div>
    </div>
  );
};

export default TemplateItem;
